import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { Fade } from "react-awesome-reveal"
import HelixIcon from "../components/helixIcon"
import WarpIcon from "../components/warpIcon"
import Hero from "../components/hero"

const ReportFindings2026 = ({ data }) => {
  const heroContent = data.markdownRemark.frontmatter.hero
  const html = data.markdownRemark.html

  return (
    <Layout classes="team">
      <Seo title={heroContent.title} description={heroContent.caption} />
      <Hero heroContent={heroContent} />
      <section className="article-content">
        {/* <HelixIcon /> */}
        {/* <WarpIcon /> */}
        <div className="container">
          <Fade triggerOnce>
            <section dangerouslySetInnerHTML={{ __html: html }} />
          </Fade>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  {
    markdownRemark(frontmatter: { template_key: { eq: "2026-report-findings" } }) {
      html
      frontmatter {
        title
        hero {
          small_title
          title
          caption
        }
      }
    }
  }
`

export default ReportFindings2026
